import { API_BASE_URL } from './utils';
import type { MdtDispatch, Resource } from '../types';

/** Build an accepted dispatch snapshot from a resource assigned on the server. */
export async function buildDispatchFromResourceAssignment(
  resource: Resource,
  incidentId: string,
  token: string
): Promise<MdtDispatch | null> {
  try {
    const res = await fetch(`${API_BASE_URL}/incidents/${encodeURIComponent(incidentId)}`, {
      headers: { Authorization: `Bearer ${token}` },
      cache: 'no-store',
    });
    if (!res.ok) return null;
    const data = await res.json();
    const incident = data.incident;
    if (!incident) return null;

    const respondedAt = resource.lastUpdate || new Date().toISOString();
    return {
      id: `ASSIGN-${incidentId}`,
      incidentId,
      eventId: incident.eventId,
      incidentTitle: incident.title,
      incidentSeverity: incident.severity,
      incidentCategory: incident.category,
      incidentLocation: incident.location,
      targetUnitId: resource.id,
      targetUnitCallSign: resource.name,
      dispatchedBy: 'CAD',
      dispatchedAt: respondedAt,
      status: 'accepted',
      respondedAt,
    };
  } catch {
    return null;
  }
}

export function dispatchListCoversIncident(
  list: MdtDispatch[],
  incidentId: string
): boolean {
  return list.some(
    (d) =>
      d.incidentId === incidentId &&
      (d.status === 'pending' || d.status === 'accepted')
  );
}
